import { actions } from './actions'

const initialState = {
  loading: false,
  data: [],
  pagination: {},
}

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case actions.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case actions.SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      }
    case actions.ERROR:
      return {
        ...initialState,
      }
    case actions.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
